export interface GmCatalogEntry {
    itemNo: number;
    name: string;
}

export function buildCategoryCatalog(itemType: number): GmCatalogEntry[] {
    const itemData = GDM.getNow('item_data');
    const table = itemData.data[itemType];
    const catalog: GmCatalogEntry[] = [];

    if (!table) {
        return catalog;
    }

    for (let itemNo = 1; itemNo < table.rowCount; ++itemNo) {
        let name = '';
        try {
            name = itemData.getName(itemType, itemNo);
        } catch (e) {
            continue;
        }
        if (name) {
            catalog.push({ itemNo, name });
        }
    }

    return catalog;
}

export function filterCatalog(catalog: GmCatalogEntry[], searchText: string): GmCatalogEntry[] {
    const needle = (searchText || '').trim().toLowerCase();
    if (!needle) {
        return catalog;
    }
    return catalog.filter((entry) => entry.name.toLowerCase().includes(needle));
}
